<template>
<v-container >
  <v-layout row wrap>
    <v-flex xs12 sm3 >
      <div style="position:sticky; top:55px; z-index:1;">

      <div class="add-page-head">
        <span :class="{'display-4 section-head d-block' : $vuetify.breakpoint.xsOnly, 'display-3 section-head d-block' : !$vuetify.breakpoint.xsOnly}">Settings</span>
        <span class="body-small font-weight-bold pt-1 d-block">Business and account settings</span>
      </div>
      <div class="" >
        <router-link v-for="item in items" :to="item.link" :key="item.title" :exact=true style="text-decoration:none;" class="body-1 d-block py-2 fadegrey--text " >{{item.title}}</router-link>
      </div>
      </div>
    </v-flex>
    <v-flex xs12 sm9 style="margin-top:30px;">
        <router-view/>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  data () {
    return {
      items: [
        // { title: 'General', icon: 'settings', link: { name: 'General' }, exact: true },
        { title: 'Business', icon: 'business', link: { name: 'Business' }, exact: false },
        { title: 'Account', icon: 'account_circle', link: { name: 'Account' }, exact: false },
        { title: 'Billing', icon: 'attach_money', link: { name: 'Billing' }, exact: false },
        { title: 'Chase emails', icon: 'attach_money', link: { name: 'ChaseEmails' }, exact: false },
        { title: 'Customer payments', icon: 'payment', link: { name: 'Payments' }, exact: false }
      ]
    }
  }
}
</script>
<style lang="scss">
h2.title {
  margin-bottom:15px;
  margin-top:35px;
}
a.v-list__tile--active{
  opacity:1;
}
.router-link-exact-active{
  font-weight:700;
}
</style>
